(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/* global initMap, mapMarkersData */
var map;
var mapEl = document.getElementById('map');

if (mapEl) {
  window.initMap = function () {
    map = new google.maps.Map(mapEl, {
      center: {
        lat: parseFloat(mapMarkersData.center_latitude),
        lng: parseFloat(mapMarkersData.center_longitude)
      },
      zoom: parseInt(mapMarkersData.google_zoom || '6'),
      controlSize: 26,
      disableDefaultUI: true,
      styles: [{
        featureType: "water",
        elementType: "geometry",
        stylers: [{
          color: "#e9e9e9"
        }, {
          lightness: 17
        }]
      }, {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{
          color: "#f5f5f5"
        }, {
          lightness: 20
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 17
        }]
      }, {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 29
        }, {
          weight: 0.2
        }]
      }, {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 18
        }]
      }, {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{
          color: "#ffffff"
        }, {
          lightness: 16
        }]
      }, {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{
          color: "#f5f5f5"
        }, {
          lightness: 21
        }]
      }, {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{
          color: "#dedede"
        }, {
          lightness: 21
        }]
      }, {
        elementType: "labels.text.stroke",
        stylers: [{
          visibility: "on"
        }, {
          color: "#ffffff"
        }, {
          lightness: 16
        }]
      }, {
        elementType: "labels.text.fill",
        stylers: [{
          saturation: 36
        }, {
          color: "#333333"
        }, {
          lightness: 40
        }]
      }, {
        elementType: "labels.icon",
        stylers: [{
          visibility: "off"
        }]
      }, {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{
          color: "#f2f2f2"
        }, {
          lightness: 19
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{
          color: "#fefefe"
        }, {
          lightness: 20
        }]
      }, {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{
          color: "#fefefe"
        }, {
          lightness: 17
        }, {
          weight: 1.2
        }]
      }]
    });

    var _loop = function _loop(i) {
      var marker = new google.maps.Marker({
        position: {
          lat: parseFloat(mapMarkersData.items.latitude[i]),
          lng: parseFloat(mapMarkersData.items.longitude[i])
        },
        map: map,
        icon: mapMarkersData.items.marker_url[i] || null
      });
      var markerInfo = new google.maps.InfoWindow({
        content: '<strong>' + mapMarkersData.items.title[i] + '</strong><br />' + mapMarkersData.items.address[i] + '<br />' + '<a href="tel:' + mapMarkersData.items.phone[i] + '">' + mapMarkersData.items.phone[i] + '</a><br />' + '<a href="' + mapMarkersData.items.website[i] + '">' + mapMarkersData.items.website[i] + '</a>'
      });
      marker.addListener('click', function () {
        markerInfo.open(map, marker);
        map.panTo(this.getPosition());
        map.setZoom(11);
      });
    };

    for (var i = 0; i < mapMarkersData.items.title.length; i++) {
      _loop(i);
    }
  };
} else {
  window.initMap = function () {};
}

(function ($) {
  $('[data-go-to-map]').on('click', function () {
    var lat = parseFloat($(this).data('latitude'));
    var lng = parseFloat($(this).data('longitude'));
    map.panTo({
      lat: lat,
      lng: lng
    });
    map.setZoom(11);
  });
})(jQuery);

},{}]},{},[1]);
